module.exports = __webpack_public_path__ + "img/Truppführer_Verpflegung.c6c54d10.svg";